<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">智慧医院智能导诊系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          在医疗数字化转型的进程中，AI
          技术正以前所未有的深度与广度融入医疗体系，重塑就医模式与医疗服务流程。海南华德科技有限公司自主研发的智能导诊系统，依托院内健康大模型与前沿技术架构，面向患者与医师提供全方位、智能化的医疗支持，打破传统医疗服务的时间与空间局限，推动医疗服务向智能化、精准化、人性化方向迈进。
        </p>
        <p class="content-paragraph">
          系统以<strong>智能导诊与分诊</strong>为入口，串联协诊开方、指引单、续方、缴费、取药、配送与复诊，形成患者端全流程闭环；同时为医师提供协诊随访、辅助诊断、疾病预测与药物推荐能力。底层由医院医疗健康大模型提供知识检索、辅助推理与持续学习支撑，在提升医疗效率、改善患者体验的同时，有效减轻医护人员工作负担。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">AI 患者端服务</h3>
            <ul class="capability-list">
              <li>智能导诊 / 分诊</li>
              <li>协诊开方</li>
              <li>协诊指引单</li>
              <li>协诊续方</li>
              <li>协诊缴费</li>
              <li>协诊取药</li>
              <li>协诊配送</li>
              <li>异常提醒</li>
              <li>协诊复诊</li>
              <li>健康宣教</li>
            </ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">AI 医师端服务</h3>
            <ul class="capability-list">
              <li>协诊随访</li>
              <li>辅助诊断</li>
              <li>药物推荐</li>
            </ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">医院医疗大模型</h3>
            <ul class="capability-list">
              <li>医疗健康数据知识清洗</li>
              <li>大模型构建（DeepSeek + RAG）</li>
              <li>医学知识库构建</li>
              <li>分层交互设计</li>
              <li>模型持续调优</li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">
          以下为系统功能示意，实际界面以项目交付成果为准。
        </p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ai-daohzhen.svg"
              alt="海南华德科技有限公司 AI 赋能医疗服务系统 - 智能导诊与患者端协诊机器人界面"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>智能导诊 · 患者端协诊机器人
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ai-doctor-workbench.svg"
              alt="海南华德科技有限公司 AI 赋能医疗服务系统 - AI 辅助诊断工作台医师端界面"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>AI 辅助诊断工作台（医师端）
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ai-medical-model.svg"
              alt="海南华德科技有限公司 AI 赋能医疗服务系统 - 医院医疗健康大模型知识图谱"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>医院医疗健康大模型知识图谱
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ai-followup.svg"
              alt="海南华德科技有限公司 AI 赋能医疗服务系统 - 协诊随访与健康管理后台"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>协诊随访与健康管理后台
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/software1.vue